/**
 * Translated Terms of Use body.
 * Mirrors the English CMS HTML for page_id "terms-of-use".
 */

const frenchTerms = `
<div class="legal-page container">
      <h1>Conditions d'utilisation</h1>
      <p class="last-updated"><em>Dernière mise à jour : octobre 2025</em></p>

      <p class="intro-text">
        En accédant à ce site et en l'utilisant, vous acceptez d'être lié par les présentes conditions. Si vous n'êtes pas d'accord, veuillez ne pas utiliser ce site.
      </p>

      <h2>📜 Acceptation des conditions</h2>
      <p>
        En accédant à ce site et en l'utilisant, vous acceptez d'être lié par les présentes conditions.
      </p>

      <h2>🚫 Utilisation du site</h2>
      <p>Vous convenez d'utiliser ce site uniquement à des fins licites. Vous ne devez pas :</p>
      <div class="info-box">
        <ul>
          <li>Utiliser le site pour une activité frauduleuse, abusive ou illégale</li>
          <li>Tenter d'accéder sans autorisation à nos systèmes ou réseaux</li>
          <li>Perturber le site ou les serveurs</li>
          <li>Transmettre des virus, des logiciels malveillants ou du code nuisible</li>
          <li>Collecter des renseignements sur d'autres utilisateurs</li>
        </ul>
      </div>

      <h2>© Propriété intellectuelle</h2>
      <p>
        Tout le contenu de ce site, y compris notamment les textes, graphiques, logos, images, extraits audio et logiciels, appartient à Cranford Publications ou à ses fournisseurs de contenu et est protégé par les lois internationales sur le droit d'auteur, les marques de commerce et la propriété intellectuelle.
      </p>
      <div class="highlight-box">
        <p><strong>Important :</strong> vous ne pouvez pas reproduire, distribuer, modifier, créer des œuvres dérivées, afficher publiquement ni exploiter le contenu sans notre autorisation écrite expresse.</p>
      </div>

      <h2>📦 Renseignements sur les produits</h2>
      <p>
        Nous nous efforçons de fournir des descriptions et des prix exacts. Nous ne garantissons toutefois pas que les descriptions, les prix ou tout autre contenu sont exacts, complets, fiables, à jour ou sans erreur. Nous nous réservons le droit de corriger toute erreur et de modifier les renseignements à tout moment, sans préavis.
      </p>

      <h2>💳 Commandes et paiements</h2>
      <p>
        Toute commande est assujettie à l'acceptation et à la disponibilité. Nous nous réservons le droit de refuser ou d'annuler une commande pour quelque raison que ce soit, y compris des limites de quantité, des erreurs de description ou de prix, ou des problèmes relevés par notre service de prévention de la fraude.
      </p>

      <h2>⚠️ Limitation de responsabilité</h2>
      <div class="info-box">
        <p>Dans la mesure maximale permise par la loi, Cranford Publications n'est pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, ni de toute perte de profits ou de revenus, de données, d'achalandage ou d'autres pertes immatérielles résultant :</p>
        <ul>
          <li>De votre accès au site, de son utilisation ou de l'impossibilité d'y accéder</li>
          <li>De la conduite ou du contenu de tout tiers sur le site</li>
          <li>De tout contenu obtenu sur le site</li>
          <li>D'un accès, d'une utilisation ou d'une modification non autorisés de vos transmissions ou de votre contenu</li>
        </ul>
      </div>

      <h2>🔔 Exclusion de garanties</h2>
      <p>
        Ce site est fourni « tel quel » et « selon disponibilité ». Nous n'offrons aucune garantie, expresse ou implicite, et déclinons toute autre garantie, y compris, sans s'y limiter, les garanties implicites de qualité marchande, d'adaptation à un usage particulier ou de non-contrefaçon.
      </p>

      <h2>🤝 Indemnisation</h2>
      <p>
        Vous convenez d'indemniser, de défendre et de dégager de toute responsabilité Cranford Publications ainsi que ses dirigeants, administrateurs, employés et mandataires à l'égard de toute réclamation, tout dommage, toute perte, toute responsabilité et toute dépense (y compris les frais juridiques) découlant de votre utilisation du site ou d'une violation des présentes conditions.
      </p>

      <h2>📝 Modifications des conditions</h2>
      <p>
        Nous nous réservons le droit de mettre à jour ou de modifier ces conditions à tout moment, sans préavis. Votre utilisation continue du site après toute modification constitue une acceptation de celles-ci.
      </p>

      <h2>⚖️ Droit applicable</h2>
      <div class="highlight-box">
        <p>Ces conditions sont régies et interprétées conformément aux lois de la <strong>province de la Nouvelle-Écosse, Canada</strong>, sans égard aux règles de conflit de lois.</p>
      </div>
    </div>
`;

const germanTerms = `
<div class="legal-page container">
      <h1>Nutzungsbedingungen</h1>
      <p class="last-updated"><em>Zuletzt aktualisiert: Oktober 2025</em></p>

      <p class="intro-text">
        Durch den Zugriff auf diese Website und ihre Nutzung akzeptieren Sie diese Bedingungen. Wenn Sie nicht einverstanden sind, nutzen Sie die Website bitte nicht.
      </p>

      <h2>📜 Zustimmung zu den Bedingungen</h2>
      <p>
        Durch den Zugriff auf diese Website und ihre Nutzung akzeptieren Sie diese Vereinbarung.
      </p>

      <h2>🚫 Nutzung der Website</h2>
      <p>Sie verpflichten sich, die Website nur für rechtmäßige Zwecke zu nutzen. Sie dürfen nicht:</p>
      <div class="info-box">
        <ul>
          <li>die Website für betrügerische, missbräuchliche oder illegale Aktivitäten nutzen</li>
          <li>unbefugt auf unsere Systeme oder Netzwerke zugreifen</li>
          <li>die Website oder Server stören</li>
          <li>Viren, Schadsoftware oder schädlichen Code übertragen</li>
          <li>Informationen über andere Nutzer sammeln</li>
        </ul>
      </div>

      <h2>© Geistiges Eigentum</h2>
      <p>
        Alle Inhalte dieser Website, einschließlich Texte, Grafiken, Logos, Bilder, Audioausschnitte und Software, sind Eigentum von Cranford Publications oder ihrer Lieferanten und durch internationale Urheber-, Marken- und sonstige Schutzrechte geschützt.
      </p>
      <div class="highlight-box">
        <p><strong>Wichtig:</strong> Sie dürfen Inhalte ohne unsere ausdrückliche schriftliche Erlaubnis nicht vervielfältigen, verbreiten, ändern, bearbeiten, öffentlich zeigen oder verwerten.</p>
      </div>

      <h2>📦 Produktinformationen</h2>
      <p>
        Wir bemühen uns um genaue Produktbeschreibungen und Preise. Wir garantieren jedoch nicht, dass Beschreibungen, Preise oder andere Inhalte vollständig, zuverlässig, aktuell oder fehlerfrei sind. Wir behalten uns vor, Fehler jederzeit ohne vorherige Ankündigung zu berichtigen.
      </p>

      <h2>💳 Bestellungen und Zahlungen</h2>
      <p>
        Alle Bestellungen unterliegen der Annahme und Verfügbarkeit. Wir behalten uns vor, Bestellungen aus jedem Grund abzulehnen oder zu stornieren, einschließlich Mengenbegrenzungen, Preis- oder Beschreibungsfehlern oder Hinweisen unserer Betrugsprävention.
      </p>

      <h2>⚠️ Haftungsbeschränkung</h2>
      <div class="info-box">
        <p>Soweit gesetzlich zulässig haftet Cranford Publications nicht für indirekte, zufällige, besondere, Folge- oder Strafschäden noch für entgangenen Gewinn, Datenverlust, Goodwill oder andere immaterielle Verluste, die entstehen aus:</p>
        <ul>
          <li>Ihrem Zugriff auf die Website, ihrer Nutzung oder der Unmöglichkeit der Nutzung</li>
          <li>dem Verhalten oder Inhalt Dritter auf der Website</li>
          <li>Inhalten, die Sie von der Website erhalten</li>
          <li>unbefugtem Zugriff, Nutzung oder Änderung Ihrer Übertragungen oder Inhalte</li>
        </ul>
      </div>

      <h2>🔔 Gewährleistungsausschluss</h2>
      <p>
        Die Website wird „wie besehen“ und „nach Verfügbarkeit“ bereitgestellt. Wir geben keine ausdrücklichen oder stillschweigenden Garantien und schließen alle weiteren Gewährleistungen aus, einschließlich stillschweigender Garantien der Marktgängigkeit, Eignung für einen bestimmten Zweck oder Nichtverletzung von Rechten.
      </p>

      <h2>🤝 Freistellung</h2>
      <p>
        Sie verpflichten sich, Cranford Publications sowie deren leitende Angestellte, Geschäftsführer, Mitarbeiter und Beauftragte von Ansprüchen, Schäden, Verlusten, Haftungen und Kosten (einschließlich Anwaltskosten) freizustellen, die aus Ihrer Nutzung der Website oder einem Verstoß gegen diese Bedingungen entstehen.
      </p>

      <h2>📝 Änderungen der Bedingungen</h2>
      <p>
        Wir behalten uns vor, diese Bedingungen jederzeit ohne vorherige Ankündigung zu ändern. Die weitere Nutzung der Website nach Änderungen gilt als Zustimmung.
      </p>

      <h2>⚖️ Anwendbares Recht</h2>
      <div class="highlight-box">
        <p>Diese Bedingungen unterliegen dem Recht der <strong>Provinz Nova Scotia, Kanada</strong>, unter Ausschluss der Kollisionsnormen.</p>
      </div>
    </div>
`;

export const TERMS_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: "Conditions d'utilisation",
    description:
      "Conditions d'utilisation du site Cranford Publications et d'achat de nos produits de musique celtique.",
    html: frenchTerms,
  },
  'fr-FR': {
    title: "Conditions d'utilisation",
    description:
      "Conditions d'utilisation du site Cranford Publications et d'achat de nos produits de musique celtique.",
    html: frenchTerms,
  },
  de: {
    title: 'Nutzungsbedingungen',
    description:
      'Nutzungsbedingungen der Website von Cranford Publications und für den Kauf unserer keltischen Musikprodukte.',
    html: germanTerms,
  },
};
